import { render, staticRenderFns } from "./EmbroideryShelfDialog.vue?vue&type=template&id=365c535f"
import script from "./EmbroideryShelfDialog.vue?vue&type=script&lang=js"
export * from "./EmbroideryShelfDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports